import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';

import { PublicacionDTO } from 'src/app/core/models/persona/interfaces';

import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlPersona;

@Injectable()
export class PublicacionService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) { }

  getPublicacionService(): Observable<BodyListResponse<PublicacionDTO>> {
    return this.http.get<BodyListResponse<PublicacionDTO>>(API_URL + '/api/v1/publicacion/todos');
  }

  guardarPublicacionService(publicacionDTO: PublicacionDTO): Observable<BodyResponse<PublicacionDTO>> {
    return this.http.post<BodyResponse<PublicacionDTO>>(API_URL + '/api/v1/publicacion', publicacionDTO);
  }

  getPublicacionPorCodigoPublicacionService(codigoPublicacion: string): Observable<BodyResponse<PublicacionDTO>> {
    return this.http.get<BodyResponse<PublicacionDTO>>(API_URL + '/api/v1/publicacion/' + codigoPublicacion);
  }
}
